class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper-parts', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.6,
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 3.5,
        }
      }
    })
    const swiperInterview = new Swiper('.c-swiper-interview', {
      speed: 800,
      spaceBetween: 110,
      slidesPerView: 1,
      centeredSlides: true,
      allowTouchMove: false,
      loop: false,
      // autoplay: {
      //   delay: 5000,  
      // },
      paginationClickable: true,
      navigation: {
        prevEl: ".c-swiper-interview__prev",
        nextEl: ".c-swiper-interview__next"
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
        }
      }
    })
    const swiperMv = new Swiper('.c-swiper-mv', {
      speed: 5000,
      slidesPerView: 1,
      effect: 'fade',
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 4000,  
        disableOnInteraction: false,
      },
    })
    const swiperImg = new Swiper('.c-swiper-img', {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,  
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      // paginationClickable: true,
    })

    const swiperThum = new Swiper('.c-swiper-thum', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.1,
      allowTouchMove: false,
      loop: true,
      touchEventsTarget: 'wrapper',
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 2.5,
        }
      }
    })

    const swiperLoop = new Swiper('.c-swiper-loop', {
      speed: 5000,
      spaceBetween: 10,
      slidesPerView: 1.1,
      allowTouchMove: false,
      loop: true,
      touchEventsTarget: 'wrapper',
      autoplay: {
        delay: 0,  
      },
      breakpoints: {
        768: {
          allowTouchMove: true,
          spaceBetween: 20,
          slidesPerView: 2.5,
          autoplay: 500,
        }
      }
    })

    $(window).on('load resize', function() {
      var windowWidth = $(window).width();
      if (windowWidth <= 768) {
        swiperLoop.startAutoplay();
      } else {
        swiperLoop.stopAutoplay();
      } 
    });
  }
}
